/* @flow */
import type { Action } from './types';

export const CHANGE_SLIDE = 'CHANGE_SLIDE';

export const changeSlide = (): Action => ({
  type: CHANGE_SLIDE
});
